import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";

import { useAxios, useApiResponseParser } from "../";

interface LaborFormulaConfig {
    expression: string;
    outputFormat?: "WholeNumber" | "Decimal";
}

export interface LaborFormulas {
    [laborItem: string]: LaborFormulaConfig;
}

export default function useLaborFormulas() {
    const { axiosPrivate } = useAxios();
    const { parseSuccessResponseData } = useApiResponseParser();
    const queryClient = useQueryClient();

    function useList() {
        return useQuery<LaborFormulas>({
            queryKey: ["labor-formulas"],
            queryFn: async () => {
                const response = await axiosPrivate.get("/v1/labor-formulas/list");
                return parseSuccessResponseData(response) as LaborFormulas;
            },
        });
    }

    function useSave() {
        return useMutation({
            mutationFn: async (data: LaborFormulas) => {
                const response = await axiosPrivate.put("/v1/labor-formulas/save", data);
                return parseSuccessResponseData(response);
            },
            onSuccess: () => {
                queryClient.invalidateQueries({ queryKey: ["labor-formulas"] });
            },
        });
    }

    return { useList, useSave };
}
